/**
 * Created by Dustin on 10.5.2018.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@common/components/modal';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';
import { Ellipsis } from '@common/components/Ellipsis';

export class ChangePasswordWnd extends Component {
    constructor (props) {
        super(props);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleRetypePasswordChange = this.handleRetypePasswordChange.bind(this);
    };

    handlePasswordChange (e) {
        e.preventDefault();
        const value = e.target.value;
        this.props.onUserDataChanged('password', value);
    };

    handleRetypePasswordChange (e) {
        e.preventDefault();
        const value = e.target.value;
        this.props.onUserDataChanged('retypedPassword', value);
    };

    render () {
        const I18n = require('react-redux-i18n').I18n;
        var topLabel = I18n.t('Passwords must contain');

        return (
            <Modal style={{top: '25%'}} dialogClassName="bootstrap-modal-medium" bsClass="bootstrap modal" show={this.props.show} onHide={this.props.onHide} animation={false}>
                <ModalHeader closeButton onHide={this.props.onHide}>
                    <ModalTitle id="lbl-title" style={{color: '#008DCE', fontWeight: 'normal'}}><Ellipsis maxWidth="calc(100% - 20px)" text={`${I18n.t('Change Password')} - ${this.props.username}`} /></ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div>{topLabel}</div>
                    <div className="row" style={{marginTop: '20px'}}>
                        <div id="lbl-password" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Password')}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-password"
                                className="form-control"
                                type="password"
                                value={this.props.password ? this.props.password : ''}
                                onChange={this.handlePasswordChange}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-retype-password" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Retype Password')}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-retype-password"
                                className="form-control"
                                type="password"
                                value={this.props.retypedPassword ? this.props.retypedPassword : ''}
                                onChange={this.handleRetypePasswordChange}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button id="btn-cancel" key="no" style={{width: "100px"}} onClick={this.props.onHide}>{I18n.t('Cancel')}</Button>
                    <Button id="btn-save" key="ok" type="submit" bsStyle="primary" style={{width: "100px"}} onClick={this.props.onSave}>{I18n.t('Save')}</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

ChangePasswordWnd.propTypes = {
    show: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onUserDataChanged: PropTypes.func.isRequired,
    username: PropTypes.string,
    password: PropTypes.string,
    retypedPassword: PropTypes.string
};